import { giphyBlack } from '@giphy/js-brand'
import styled, { css } from 'styled-components'
import ControlSize, {
    controlBorderRadius,
    controlFontShadow,
    controlFontSize,
    controlHeight,
} from '../../../types/control-size'
import Gradient, { gradientCss } from '../../../types/gradient'
import { brightnessFromColor } from '../../../utils/color/brightness'
import SliderComponent from './dnd'

export const Container = styled.div<{ backgroundColor: string; controlSize: ControlSize; disabled: boolean }>`
    font-weight: bold;
    position: relative;
    user-select: none;

    ${({ backgroundColor, controlSize }) => css`
        background: ${backgroundColor};
        border-radius: ${controlBorderRadius(controlSize)}px;
        font-size: ${controlFontSize(controlSize)}px;
        height: ${controlHeight(controlSize)}px;
    `}

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`

export const Slider = styled(SliderComponent)<{
    backgroundColor: string
    controlColor?: string
    gradient?: Gradient
    textColor?: string
}>`
    bottom: 0;
    position: absolute;
    top: 0;

    ${({ backgroundColor, controlColor, gradient, textColor }) => {
        if (!!gradient) {
            return css`
                background: ${gradientCss(gradient)};
                color: ${textColor || '#fff'};
            `
        }

        if (!!controlColor) {
            return css`
                background: ${controlColor};
                color: ${textColor || (brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff')};
            `
        }

        return css`
            background: linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.3));
            color: ${textColor || (brightnessFromColor(backgroundColor) > 0.5 ? giphyBlack : '#fff')};
        `
    }}
`

export const Children = styled.div<{ controlSize: ControlSize; gradient?: Gradient }>`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    height: 100%;
    overflow: hidden;
    width: 100%;

    ${({ controlSize, gradient }) =>
        gradient &&
        css`
            filter: drop-shadow(${controlFontShadow(controlSize)});
        `}
`
